"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _user.default;
  }
});
require("@webex/internal-plugin-device");
var _webexCore = require("@webex/webex-core");
var _user = _interopRequireDefault(require("./user"));
var _config = _interopRequireDefault(require("./config"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerInternalPlugin)('user', _user.default, {
  config: _config.default
});
//# sourceMappingURL=index.js.map
